import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n/i18n";
import { SnackbarProvider } from 'notistack';
import store from "./store/store";
ReactDOM.render(
  <>  <SnackbarProvider maxSnack={1}>
      <App store={store}/>
  </SnackbarProvider>

  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
